// ----------------------------------------------------------------------
// <copyright file="Izenda.AddItemPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * AddItemPopup Component
 */
!(function () {

  var React = require('react');
  var PopupInput = require('share/components/controls/Izenda.PopupInput');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var EventsUtils = require('EventUtils');
  var classnames = require('classnames'); 
  var localizer = require('share/localization/Izenda.Localizer');
  
  /**
   * Popup content component
   */
  var AddItemPopupContent = React.createClass({

    /**
    * Get initial state for component
    * @return {object}  state of component
    */
    getInitialState: function () {
      return {
        selectValue: CONSTANTS.HEADER_FOOTER.items[0].value
      };
    },

    /**
     * Handle on change item add to format
     * @param  {string} value value select on dropdown list
     */
    onChangeSelectItem: function (value) {
      this.setState({ selectValue : value})
    },

    /**
     * Handle get value when click ok button
     * @return {string} select value
     */
    getValue: function(){
      return this.state.selectValue;
    },

    /**
     * Render component
     * @return {object} react component
     */
    render: function () {
      return ( <div className='add-item-popup-content'>
                <span>To add an item, select a type:</span>
                <DropDown className='selection-item'
                          options={CONSTANTS.HEADER_FOOTER.items}
                          valueField='value'
                          labelField='label'
                          onChange={EventsUtils.notifyChange(this.onChangeSelectItem, EventsUtils.DROPDOWN)}
                          value={this.state.selectValue}/>
               </div>)
    },
  });

  /**
   * Add item popup component
   */
  var AddItemPopup = React.createClass({

    /**
     * Define component props
     */
    propTypes: {
      onChange: React.PropTypes.func.isRequired
    },

    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function (value) {
      this.props.onChange && this.props.onChange(value);
    },

    /**
    * Render component
    * @return {[type]} [description]
    */
    render: function () {
      var className = classnames('add-format-item', this.props.className);
      return (<PopupInput containerClassName={className}
                          className='btn btn-primary'
                          label={localizer.getText('REPORTDESIGNER_LABEL_ADD_ITEM')}
                          onChange={this.onChange}
                          popupProps={{
                            type: 'none',
                            autoClose: true,
                            sizeClass: 'modal-sm'
                          }}
                          popupTitle={localizer.getText("REPORTDESIGNER_LABEL_ADD_ITEM")}
                          popupContent={AddItemPopupContent}/>);
    }
  });
  
  module.exports = AddItemPopup;

}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Formats/Izenda.AddItemPopup.jsx